import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Phpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csmethod(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  const right = {
    padding: '0 0 0 '+padding+'rem',
  };
return(
      <div>
      <Sides/>
  
      <Helmet>
 
 <title>Learn Free PHP Function Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="Php Method tutorial for beginners.The Php methods contain one more statement and each method performs only one task, CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,php function mail,php function list,php function header,php function explode,php function array,php function call,php function string,php function return,php functions,what is php function,Php Method, php function,Php Method for,Php foreach Method" />
 <link rel="canonical" href="https://www.codeexampler.com/php-function" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">What is PHP Function</h1>
    <div className="first">
        <a href="/php-goto">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-user-define-function">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para">The Php methods contain one more statement, and each technique performs only one task.
        <br/>
        Each method gives a name, and after this name is used to call the method.
    </p>


<h2 className="headings">Function in Php Syntax:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-1">Method </span>
            <span className="qwerty-2">name </span>
            <span className="qwerty-4">(</span>
              <span className="qwerty-6">parenthesis</span>
            <span className="qwerty-3"> or</span>
            <span className="qwerty-5"> parameter</span>
            <span className="qwerty-3"> -list</span>
            <span className="qwerty-4">)</span>
            {"\n"}
            <span className="qwerty-7"> &#123; </span>
            {"\n"} 
            <span className="qwerty-10">  &#47;&#47;body of the method</span>
              {"\n"}
              <span className="qwerty-7"> &#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>



<h2 className="headings">Q-Write a Program use one method in Php?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-2">?</span>
            <span className="qwerty-4">php </span>
            {"\n"}
            <span className="qwerty-2">function </span>
            <span className="qwerty-5">teachers </span>
            <span className="qwerty-3">() </span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} 
            <span className="qwerty-9">Echo </span>
            <span className="qwerty-3"> "</span>
            <span className="qwerty-5">teaching</span>
            <span className="qwerty-3">";</span>
              {"\n"}
              <span className="qwerty-3"> &#125; </span>
            {"\n"}
            <span className="qwerty-9">Echo </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-3">Start method</span>
            <span className="qwerty-9"> \</span>
            <span className="qwerty-4">n</span>
           
            <span className="qwerty-3">";</span>
            {"\n"}
            <span className="qwerty-5"> teachers </span>
            <span className="qwerty-3">(); </span>
            {"\n"}
            <span className="qwerty-2"> ?</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
            <code>
            {"\n"} 
            <span className="qwerty-10">start </span>
              <span className="qwerty">method </span>
              {"\n"}
              <span className="qwerty-4">teaching </span>
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>



<h2 className="headings">Q-Write a Program uses two functions in Php?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-2">?</span>
            <span className="qwerty-4">php </span>
            {"\n"}
            <span className="qwerty-2">function </span>
            <span className="qwerty-10">Code </span>
            <span className="qwerty-3">() </span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} 
            <span className="qwerty-9">Echo </span>
            <span className="qwerty-3"> "</span>
            <span className="qwerty-5">CodeExampler</span>
            <span className="qwerty-9"> \</span>
            <span className="qwerty-4">n</span>

            <span className="qwerty-3">";</span>
              {"\n"}
              <span className="qwerty-3"> &#125; </span>
            {"\n"}
            <span className="qwerty-2">function </span>
            <span className="qwerty-10">Ram </span>
            <span className="qwerty-3">() </span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} 
            <span className="qwerty-9">Echo </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-3">Hello Ram</span>
            <span className="qwerty-9"> \</span>
            <span className="qwerty-4">n</span>
            <span className="qwerty-3">";</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"}
            <span className="qwerty-10"> Code </span>
            <span className="qwerty-3">(); </span>
            {"\n"}
            <span className="qwerty-10"> Ram </span>
            <span className="qwerty-3">(); </span>
            {"\n"}
            <span className="qwerty-10"> Code </span>
            <span className="qwerty-3">(); </span>
            {"\n"}
            <span className="qwerty-10"> Code </span>
            <span className="qwerty-3">(); </span>
            {"\n"}
            <span className="qwerty-10"> Code </span>
            <span className="qwerty-3">(); </span>
            {"\n"}
            <span className="qwerty-2"> ?</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
            <code>
            {"\n"} 
            <span className="qwerty-10">CodeExampler </span>
              {"\n"}
              <span className="qwerty">Hello </span>
              <span className="qwerty-5">Ram </span>
              {"\n"}
              <span className="qwerty-10">CodeExampler </span>
              {"\n"}
              <span className="qwerty-10">CodeExampler </span>
              {"\n"}
              <span className="qwerty-10">CodeExampler </span>
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>



<h2 className="headings">Q-Write a Program Use two methods and create different objects for different functions in Php?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-2">?</span>
            <span className="qwerty-4">php </span>
            {"\n"}
            <span className="qwerty-2">function </span>
            <span className="qwerty-10">teachers </span>
            <span className="qwerty-3">() </span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-9">Echo </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-3">Teaching</span>
            <span className="qwerty-9"> \</span>
            <span className="qwerty-4">n</span>
            <span className="qwerty-3">";</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} 
            <span className="qwerty-2">function </span>
            <span className="qwerty-10">students</span>
            <span className="qwerty-3"> ()</span>
              {"\n"}
              <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-1">Echo </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-5">Learn </span>
            <span className="qwerty-3">";</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} 
            <span className="qwerty-1">Echo </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-3">Start Class</span>
            <span className="qwerty-9"> \</span>
            <span className="qwerty-4">n</span>
            <span className="qwerty-3">";</span>
            {"\n"}
            <span className="qwerty-10"> teachers </span>
            <span className="qwerty-3">(); </span>
            {"\n"}
            <span className="qwerty-10"> students </span>
            <span className="qwerty-3">(); </span>
            {"\n"}
            <span className="qwerty-2"> ?</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
            <code>
            {"\n"} 
            <span className="qwerty-10">Start </span>
            <span className="qwerty-6">Class</span>
              {"\n"}
              <span className="qwerty">Teaching</span>
              {"\n"}
              <span className="qwerty-4">Learn </span>
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>


<h2 className="mt-4 mh2">Important:</h2>
<p className="mt-4 para">You create multiple objects you do, but programming run speed decreases, creating fewer objects to gain high speed and if you search <a  style={{textDecoration: 'none'}} target="_blank"  href="https://www.codeexampler.com/cpp-if-else" >Else if in C++ Tutorial for Beginners</a> So Learn C++ with lot of Examples
</p>



<h2 className="headings">Q-Write a Program uses a different class on Php Method Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-2">?</span>
            <span className="qwerty-4">php </span>
            {"\n"}
            <span className="qwerty-9">function </span>
            <span className="qwerty-7">teachers </span>
            <span className="qwerty-3">() </span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-2">Echo </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty">Teaching</span>
            <span className="qwerty-9"> \</span>
            <span className="qwerty-4">n</span>
            <span className="qwerty-3">";</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} 
            <span className="qwerty-9">function </span>
            <span className="qwerty-5">students</span>
            <span className="qwerty-3"> ()</span>
              {"\n"}
              <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-2">Echo </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-5">Learn</span>
            <span className="qwerty-9"> \</span>
            <span className="qwerty-4">n</span>
            <span className="qwerty-3">";</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} 
            <span className="qwerty-2">Echo </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-3">Start Class</span>
            <span className="qwerty-9"> \</span>
            <span className="qwerty-4">n</span>
            <span className="qwerty-3">";</span>
            {"\n"}
            <span className="qwerty-7"> teachers </span>
            <span className="qwerty-3">(); </span>
            {"\n"}
            <span className="qwerty-5"> students </span>
            <span className="qwerty-3">(); </span>
            {"\n"}
            <span className="qwerty-7"> Peon </span>
            <span className="qwerty-3">(); </span>
            {"\n"}
            <span className="qwerty-9">function </span>
            <span className="qwerty-7">Peon</span>
            <span className="qwerty-3"> ()</span>
              {"\n"}
              <span className="qwerty-3"> &#123; </span>
            {"\n"} 
            <span className="qwerty-2">Echo </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-3">Ring </span>
            <span className="qwerty-9">the </span>
            <span className="qwerty-4">bell</span>
            <span className="qwerty-3">";</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} 
            <span className="qwerty-2"> ?</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
            <code>
            {"\n"} 
            <span className="qwerty-10">Start </span>
            <span className="qwerty-6">Class</span>
              {"\n"}
              <span className="qwerty">Teaching</span>
              {"\n"}
              <span className="qwerty-4">Learn </span>
              {"\n"} 
            <span className="qwerty-10">Ring </span>
            <span className="qwerty-5">the </span>
            <span className="qwerty-6">bell</span>
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>

  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/php-goto">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-user-define-function">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>

        </div>
    </div>
)

}
export default Csmethod;